import { useCallback, useMemo } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { Number3, VisibilityBoxMode } from '@abyss/3d-viewer';
import { CuboidBase, CuboidState } from '../types';

const smallVisibilityBoxStep: Number3 = [0.001, 0.001, 0.001];

export const useCuboidVisibilityBox = <CuboidT extends CuboidBase>(
  cuboidState: CuboidState<CuboidT>
) => {
  const [currentCuboid] = useAtom(cuboidState.currentCuboid);
  const isCuboidVisibilityBoxEnabled = useAtomValue(cuboidState.isCuboidVisibilityBoxEnabled);

  const smallVisibilityBox = useMemo(() => {
    if (!currentCuboid || !isCuboidVisibilityBoxEnabled) return undefined;
    const { position, rotation, scale } = currentCuboid;
    return {
      mode: VisibilityBoxMode.Enabled,
      position,
      rotation,
      scale,
      step: smallVisibilityBoxStep,
    };
  }, [isCuboidVisibilityBoxEnabled, currentCuboid]);

  const setSmallVisibilityBox = useCallback(() => {}, []);

  return { smallVisibilityBox, setSmallVisibilityBox };
};
